import { createEventDefinition } from 'ts-bus';
import type { Site } from '@hotjar/site';

export const EVENT_TRACKING_CODE_INSTALLED = 'EVENT_TRACKING_CODE_INSTALLED';

export const EVENT_TRACKING_CODE_MODAL_OPENED = 'EVENT_TRACKING_CODE_MODAL_OPENED';

export const EVENT_TRACKING_CODE_VERIFICATION_FINISHED =
  'EVENT_TRACKING_CODE_VERIFICATION_FINISHED';

export const trackingCodeInstalled = createEventDefinition<{
  site: Site;
}>()(EVENT_TRACKING_CODE_INSTALLED);

export const trackingCodeVerificationFinished = createEventDefinition<{
  site: Site;
}>()(EVENT_TRACKING_CODE_VERIFICATION_FINISHED);

export const trackingCodeModalOpened = createEventDefinition<{
  site: Site;
  activeTab: 'install' | 'verify';
}>()(EVENT_TRACKING_CODE_MODAL_OPENED);
